var _a;
import { otto } from "./nexus-client.mjs";
const device = ((_a = window.o_global) == null ? void 0 : _a.device) ?? {};
const {
  Hybrid,
  Orientation,
  breakpoint,
  browser,
  hybrid,
  isTouchable,
  orientation,
  os,
  screen,
  type
} = device;
const getPointerType = (otto.device ?? {}).getPointerType;
export {
  Hybrid,
  Orientation,
  breakpoint,
  browser,
  device,
  getPointerType,
  hybrid,
  isTouchable,
  orientation,
  os,
  screen,
  type
};
/*                                      */
